import pagination from '../../utils/pagination'
import {
  TEAMS_BATCH_DELETE_REQUEST, TEAMS_BATCH_DELETE_SUCCESS, TEAMS_BATCH_DELETE_FAILURE,
  TEAMS_FETCH_MANY_REQUEST, TEAMS_FETCH_MANY_SUCCESS, TEAMS_FETCH_MANY_FAILURE,
  TEAMS_FETCH_MANY_NO_PAGINATE_REQUEST, TEAMS_FETCH_MANY_NO_PAGINATE_SUCCESS, TEAMS_FETCH_MANY_NO_PAGINATE_FAILURE,
  TEAMS_FETCH_REQUEST, TEAMS_FETCH_SUCCESS, TEAMS_FETCH_FAILURE,
  TEAMS_SAVE_REQUEST, TEAMS_SAVE_SUCCESS, TEAMS_SAVE_FAILURE,

  EMPTY_TEAMS,
  CLEAR_ERRORS
} from './types'

export default {
  [TEAMS_BATCH_DELETE_REQUEST] (state) {
    state.deleting = true
  },
  [TEAMS_BATCH_DELETE_SUCCESS] (state) {
    state.deleting = false
  },
  [TEAMS_BATCH_DELETE_FAILURE] (state) {
    state.deleting = false
  },
  [TEAMS_FETCH_MANY_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [TEAMS_FETCH_MANY_SUCCESS] (state, { data }) {
    state.data = data.data
    state.page = pagination(data)
    state.loading = false
  },
  [TEAMS_FETCH_MANY_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [TEAMS_FETCH_MANY_NO_PAGINATE_REQUEST] (state) {
    state.data = []
    state.loading = true
  },
  [TEAMS_FETCH_MANY_NO_PAGINATE_SUCCESS] (state, { data }) {
    state.data = data
    state.loading = false
  },
  [TEAMS_FETCH_MANY_NO_PAGINATE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.loading = false
  },
  [TEAMS_FETCH_REQUEST] (state) {
    state.single = {}
    state.loading = true
  },
  [TEAMS_FETCH_SUCCESS] (state, { data }) {
    state.single = data
    state.loading = false
  },
  [TEAMS_FETCH_FAILURE] (state) {
    state.loading = false
  },
  [TEAMS_SAVE_REQUEST] (state) {
    state.data = []
    state.saving = true
  },
  [TEAMS_SAVE_SUCCESS] (state) {
    state.saving = false
  },
  [TEAMS_SAVE_FAILURE] (state, { validationErrors }) {
    state.validationErrors = validationErrors || {}
    state.saving = false
  },
  [EMPTY_TEAMS] (state) {
    state.data = []
    state.loading = false
    state.saving = false
  },
  [CLEAR_ERRORS] (state) {
    state.validationErrors = []
    state.loading = false
    state.saving = false
  },
}
